<template>
	<b-row class="my-2">
		<b-col cols="12" class="font-weight-bold">{{ label }}</b-col>
		<b-col cols="12">
			<div class="border p-1 my-1 base-textbox">
				{{ text }}
			</div>
		</b-col>
	</b-row>
</template>
<script>
	export default {
		name: 'textbox',
		props: ['label', 'text']
	}
</script>
<style scoped>

.base-textbox {
	display: block;
	width: 100%;
	height: 8em;
}

</style>